module.exports = {"652702001":"阿拉套街道","652702100":"艾比湖镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652702.json
// module id = 3079
// module chunks = 0